import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {DIALECT_BOOKMARK_API_URL} from '../../defines/protocol';
import {DialectService} from './dialect.service';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class DialectBookmarkService extends DialectService {

  constructor(
    protected override api: ApiService,
  ) {
    super(api);
    this.urlApi = DIALECT_BOOKMARK_API_URL;
  }

  /**
   * 사투리을 책갈피에 추가/삭제하도록 서버에 요청
   * 화면(listDialect)와는 관계 없다.
   * @param id: 추가할 사투리 번호
   * @param add: 추가/삭제 여부
   */
  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('sendBookmark', id, add, data);
        return data;
      }),
      // catchError((err, caught) => {
      //   console.error('sendBookmark', id, add, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }

  /**
   * 지정한 사투리을 표시 목록에서 제거한다.
   * this.listDialect 에서 제거하면 화면에서 지워진다.
   * @param id: 제거할 사투리 번호
   */
  public hideBookmark(id: string): void {
    if (this.listDialect === null) {
      throw new Error('DialectBookmarkService::hideBookmark() listDialect is null');
    }
    else if (this.totalCount === null) {
      throw new Error('DialectBookmarkService::hideBookmark() totalCount is null');
    }

    const idx = this.listDialect.findIndex(dialect => dialect.id === id);
    if (idx !== -1) {
      this.listDialect.splice(idx, 1);
      --this.totalCount;
    }
    else {
      console.warn(`DialectBookmarkService::hideBookmark(${id}) dialect does not exist`);
    }
  }
}
